import {SCHEDULE_SESSION_DISPLAY_TYPE_SPEEDDATE} from 'common-data-handling';

/**
 * Checks if the given session is a speeddate.
 *
 * @param {Object} session - The session object to check.
 * @return {boolean} Returns true if the session is a speeddate, false otherwise.
 */
export function isSpeeddate(session) {
    return session?.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_SPEEDDATE;
}
